import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';

const disabledLinkStyle = css`
  color: #abacaf;
  pointer-events: none;
`;

export const LinkWrapper = styled.span<{ isActived?: boolean; isDisabled?: boolean }>`
  a {
    padding: 5.5px 12px;
    border: 1px solid transparent;
    color: ${({ theme, isActived }) =>
      isActived ? theme.colors['primary-60'] : theme.colors['neutral-80']};
    font-size: 14px;
    line-height: 21px;
    border-radius: 4px;
    ${({ isDisabled = false }) => isDisabled && disabledLinkStyle};

    &:not(:hover):after {
      content: '';
      position: absolute;
      width: 4px;
      height: 4px;
      background: ${({ theme, isDisabled }) =>
        isDisabled ? theme.colors['neutral-50'] : theme.colors['primary-60']};
      border-radius: 50%;
      bottom: -1.5px;
      left: 0;
      right: 0;
      margin: auto;
      display: ${(props) => (props.isActived ? 'initial' : 'none')};
    }

    &:hover {
      border-color: ${({ theme }) => theme.colors['neutral-40']};
    }

    &:active {
      color: ${(props) => props.theme.colors['primary-30']};
    }
  }
`;

export const TopBarLink = styled(Link)`
  font-size: 14px;
  line-height: 21px;
  font-weight: 400;
  position: relative;
  transition: color 0.4s ease;
`;

export const LinksArea = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    margin-bottom: 0;
  }
  @media (max-width: 767px) {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    &::-webkit-scrollbar {
      display: none;
    }
  }
`;
